import type { ReactNode } from 'react';
import stars from '@/features/payments/assets/stars.webp';
import type { OfferReview } from '../types';
import verifiedIcon from '../assets/icon-verified.svg';

interface OfferReviewsProps {
  title: ReactNode;
  reviews: OfferReview[];
}

export function OfferReviews({ title, reviews }: OfferReviewsProps) {
  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-center font-display text-[28px] font-bold leading-9 text-mf-neutral-900">
        {title}
      </h2>
      <div className="flex flex-col gap-2">
        {reviews.map((review) => (
          <article
            key={review.name}
            className="flex flex-col gap-5 rounded-[20px] bg-white px-4 pb-4 pt-5 shadow-[0_0_8px_rgba(26,22,19,0.03)]"
          >
            <div className="flex flex-col gap-2">
              <img src={stars} alt="" className="h-5 w-[124px]" />
              <p className="font-body text-[15px] font-normal leading-5 text-mf-neutral-600">{review.text}</p>
            </div>
            <div className="flex items-center gap-2.5">
              <div className="flex min-w-0 flex-1 items-center gap-2">
                <img
                  src={review.avatar}
                  alt=""
                  className="size-10 rounded-full object-cover"
                />
                <span className="font-body text-base font-bold leading-5 text-mf-neutral-900">
                  {review.name}
                </span>
              </div>
              <span
                className="flex shrink-0 items-center gap-1 overflow-hidden rounded-full py-1 pl-1 pr-2"
                style={{
                  backgroundImage: 'linear-gradient(72.23deg, #4fa82b 0%, #11aa59 100%)',
                }}
              >
                <img src={verifiedIcon} alt="" className="size-4" />
                <span className="font-body text-xs font-bold leading-4 text-white">Verified review</span>
              </span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
